<div class="public-profile-manager-container directory-background">
    <div class="wrapper">
        <a class="header-back-container" (click)="onHeaderBackClick()">
            <span *ngIf="!hasHistory">{{ 'publicProfiles.manager.text1' | translate:locale.language }}</span>
            <mat-icon *ngIf="hasHistory" fontSet="phr-iconset" class="phr-iconset-PHR-Volver"></mat-icon>
        </a>
        <div>
            <app-form></app-form>
        </div>
    </div>    
</div>

